export { Newsletter as default } from 'owl-nest/bob/features/newsletter/src'
